import { Box, Stack, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { Outlet } from "react-router-dom";

type MainContentLayoutProps = {
    children?: ReactNode;
};
export const MainContentLayout = (props: MainContentLayoutProps) => {
    const theme = useTheme();

    return (
        <Stack
            sx={{
                display: "flex",
                padding: theme.spacing(5, 6.5),
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: theme.breakpoints.values.xl,
                }}
            >
                {props.children ? props.children : <Outlet />}
            </Box>
        </Stack>
    );
};
